export * from './customer-summary.component';
export * from './customer-summary.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/customer-summary/index.ts